import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortProducts'
})
export class SortProductsPipe implements PipeTransform {
  transform(products: any[]): any {
    return products.sort((a, b) => {
      if (a.display_order > b.display_order) {
        return 1;
      } else {
        return -1;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/pipe/sort-products.pipe.ts